import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6693c822")

_pushScopeId("data-v-6693c822")
const _hoisted_1 = { class: "SenderCreate" }
const _hoisted_2 = { class: "SenderCreate__MapFooter" }
const _hoisted_3 = { class: "MapFooter__address" }
const _hoisted_4 = { class: "address__description" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Геокодирование при помощи ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Yandex")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("2GIS")
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "address__title" }, "Выбранный адрес:", -1)
const _hoisted_9 = { class: "address__result" }
const _hoisted_10 = { class: "address__text" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Геокодируем адрес... ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Ошибка при поиске адреса ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Поставьте точку на карте ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
const _hoisted_15 = { class: "SenderCreate__header" }
const _hoisted_16 = { class: "header__title" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Новый отправитель")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Редактирование отправителя")
const _hoisted_19 = { class: "SenderCreate__form" }
const _hoisted_20 = { class: "form__side form__left" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "form__label" }, "Укажите основную информацию об отправителе", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { class: "form__label left-margin" }, "Укажите контактные данные отправителя", -1)
const _hoisted_23 = { class: "form__side form__right" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "form__label" }, " Укажите информацию об адресе отправителя и укажите на карте ", -1)
const _hoisted_25 = { class: "form__row" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Указать ")
const _hoisted_27 = {
  key: 1,
  class: "warehouse_message"
}
const _hoisted_28 = { class: "SenderCreate__footer" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Создать")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Изменить")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_map_search = _resolveComponent("s-map-search")!
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_icon_location = _resolveComponent("icon-location")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_s_map = _resolveComponent("s-map")!
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_icon_search = _resolveComponent("icon-search")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_icon_person = _resolveComponent("icon-person")!
  const _component_s_phone_number = _resolveComponent("s-phone-number")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_icon_dots = _resolveComponent("icon-dots")!
  const _component_icon_lattice = _resolveComponent("icon-lattice")!
  const _component_icon_comment = _resolveComponent("icon-comment")!
  const _component_s_textarea = _resolveComponent("s-textarea")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_s_map, {
      onClose: _ctx.closeMap,
      onClick: _ctx.mapClicked,
      onMapCreated: _ctx.mapCreated,
      onMapSwitched: _ctx.mapSwitched
    }, {
      layer: _withId(() => [
        _createVNode(_component_s_map_search, {
          city: _ctx.state.city,
          "geocode-by-yandex": _ctx.mapState.is_yandex || _ctx.mapState.is_google,
          "geocode-by-gis": _ctx.mapState.is_gis,
          onSelect: _ctx.resultFinded
        }, null, 8, ["city", "geocode-by-yandex", "geocode-by-gis", "onSelect"])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("p", _hoisted_4, [
              _hoisted_5,
              _createVNode("b", null, [
                (_ctx.mapState.is_yandex || _ctx.mapState.is_google)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_6
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.mapState.is_gis)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_7
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              (_ctx.addressState.is_loading)
                ? (_openBlock(), _createBlock(_component_s_loader, {
                    key: 0,
                    class: "address__icon"
                  }))
                : (_ctx.addressState.is_finded)
                  ? (_openBlock(), _createBlock(_component_icon_location, {
                      key: 1,
                      class: "address__icon"
                    }))
                  : _createCommentVNode("", true),
              _createVNode("p", _hoisted_10, [
                (_ctx.addressState.is_loading)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_11
                    ], 64))
                  : (_ctx.addressState.is_failed)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _hoisted_12
                      ], 64))
                    : (!_ctx.addressState.is_finded)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                          _hoisted_13
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_ctx.addressState.address), 1)
                        ], 64))
              ])
            ])
          ]),
          _createVNode(_component_s_button, {
            class: { red: _ctx.isFTL, primary: _ctx.isLTL, blue: !_ctx.isFTL && !_ctx.isLTL },
            onClick: _ctx.setFullAddress,
            disabled: !_ctx.addressState.is_finded
          }, {
            default: _withId(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["class", "onClick", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onClose", "onClick", "onMapCreated", "onMapSwitched"]), [
      [_vShow, _ctx.isMapOpened]
    ]),
    (!_ctx.isMapOpened)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_15, [
            _createVNode("h2", _hoisted_16, [
              (_ctx.isCREATE)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_17
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isUPDATE)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_18
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_icon_close, {
              class: "header__close",
              onClick: _ctx.emitClose
            }, null, 8, ["onClick"])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_s_input, {
                placeholder: "Наименование отправителя",
                value: _ctx.state.title,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.title = $event)),
                "is-invalid": Boolean(_ctx.v$.title.$errors.length)
              }, {
                icon: _withId(() => [
                  _createVNode(_component_icon_search)
                ]),
                _: 1
              }, 8, ["value", "is-invalid"]),
              _hoisted_22,
              _createVNode(_component_s_input, {
                placeholder: "Имя и фамилия",
                value: _ctx.state.full_name,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.full_name = $event)),
                "is-invalid": Boolean(_ctx.v$.full_name.$errors.length)
              }, {
                icon: _withId(() => [
                  _createVNode(_component_icon_person)
                ]),
                _: 1
              }, 8, ["value", "is-invalid"]),
              _createVNode(_component_s_phone_number, {
                placeholder: "Телефон",
                value: _ctx.state.phone,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.phone = $event)),
                "is-invalid": Boolean(_ctx.v$.phone.$errors.length)
              }, null, 8, ["value", "is-invalid"]),
              _createVNode(_component_s_phone_number, {
                placeholder: "Дополнительный телефон",
                value: _ctx.state.additional_phone,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.additional_phone = $event)),
                "is-invalid": Boolean(_ctx.v$.additional_phone.$errors.length)
              }, null, 8, ["value", "is-invalid"])
            ]),
            _createVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_multiselect, {
                modelValue: _ctx.state.city,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.city = $event)),
                class: { invalid: _ctx.v$.city.$errors.length },
                options: _ctx.senderCities.data,
                object: true,
                loading: _ctx.senderCities.state.is_loading,
                label: "name",
                trackBy: "name",
                placeholder: "Город",
                searchable: "",
                noResultsText: "Ничего не найдено",
                noOptionsText: "Список пуст",
                onChange: _ctx.onCityChange
              }, null, 8, ["modelValue", "class", "options", "loading", "onChange"]),
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_s_input, {
                  placeholder: "Адрес",
                  disabled: "",
                  value: _ctx.state.full_address,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.full_address = $event)),
                  "is-invalid": Boolean(_ctx.v$.full_address.$errors.length)
                }, {
                  icon: _withId(() => [
                    _createVNode(_component_icon_location)
                  ]),
                  _: 1
                }, 8, ["value", "is-invalid"]),
                _createVNode(_component_s_button, {
                  class: { red: _ctx.isFTL, primary: _ctx.isLTL, blue: !_ctx.isFTL && !_ctx.isLTL },
                  onClick: _ctx.openMap,
                  disabled: Boolean(_ctx.state.warehouse_id) || !_ctx.isMapCreated
                }, {
                  default: _withId(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }, 8, ["class", "onClick", "disabled"])
              ]),
              (_ctx.isLTL)
                ? (_openBlock(), _createBlock(_component_s_checkbox, {
                    key: 0,
                    value: _ctx.warehouses_state.is_opened,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.warehouses_state.is_opened = $event)),
                    theme: "primary",
                    label: "Самопривоз",
                    onChange: _ctx.onWarehouseToggle
                  }, null, 8, ["value", "onChange"]))
                : _createCommentVNode("", true),
              (_ctx.warehouses_state.is_opened && !_ctx.warehouses_state.warehouse)
                ? (_openBlock(), _createBlock("p", _hoisted_27, " В выбранном городе склад не найден, пожалуйста выберите другой город "))
                : _createCommentVNode("", true),
              _createVNode(_component_s_input, {
                placeholder: "Индекс",
                value: _ctx.state.index,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.index = $event)),
                "is-invalid": Boolean(_ctx.v$.index.$errors.length),
                disabled: Boolean(_ctx.state.warehouse_id)
              }, {
                icon: _withId(() => [
                  _createVNode(_component_icon_dots)
                ]),
                _: 1
              }, 8, ["value", "is-invalid", "disabled"]),
              _createVNode(_component_s_input, {
                placeholder: "Номер квартиры/офиса",
                value: _ctx.state.office,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.office = $event)),
                "is-invalid": Boolean(_ctx.v$.office.$errors.length),
                disabled: Boolean(_ctx.state.warehouse_id)
              }, {
                icon: _withId(() => [
                  _createVNode(_component_icon_lattice)
                ]),
                _: 1
              }, 8, ["value", "is-invalid", "disabled"]),
              _createVNode(_component_s_textarea, {
                placeholder: "Комментарий к адресу",
                value: _ctx.state.comment,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.comment = $event))
              }, {
                icon: _withId(() => [
                  _createVNode(_component_icon_comment)
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createVNode("div", _hoisted_28, [
            _createVNode(_component_s_button, {
              class: { red: _ctx.isFTL, primary: _ctx.isLTL, blue: !_ctx.isFTL && !_ctx.isLTL },
              onClick: _ctx.emitConfirm,
              loading: _ctx.isSenderActionsLoading
            }, {
              default: _withId(() => [
                (_ctx.isCREATE)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_29
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isUPDATE)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_30
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class", "onClick", "loading"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})